import { login } from '@/api/api.js'
export function loginSuper(call) {
  let params = {
    username: "super",
    password: "YdbXt@2580%",
  }
  login(params).then((res) => {
    document.onkeydown = undefined;
    if (res.code == '500') {
      this.$message.error(res.message);
    } else if (res.message == '用户名不存在') {
      this.$message.error(res.message);
    } else {
      //获取当前用户省市县类型
      let regionCode = res.data.regionCode;
      let type = 0;
      if (regionCode == '' || (regionCode[2] == '0' && regionCode[3] == '0' && regionCode[4] == '0' && regionCode[5] == '0')) {
        type = 0;
      } else if (regionCode[4] == '0' && regionCode[5] == '0') {
        type = 1;
      } else {
        type = 2;
      }
      // this.$store.commit('toKen', res.token); //token
      // this.$store.commit('userId', res.data.id); //用户id
      // this.$store.commit('naMe', res.data.username); //用户名
      // this.$store.commit('unIt', res.data.unit); //用户单位
      // this.$store.commit('Tel', res.data.tel); //用户电话
      // this.$store.commit('Type', type); //用户省市县类型
      // this.$store.state.roleCode = res.data.roleCodes;//角色code

      localStorage.setItem('toKen', res.token);
      localStorage.setItem('userId', res.data.id);
      localStorage.setItem('naMe', res.data.username);
      localStorage.setItem('unIt', res.data.unit);
      localStorage.setItem('Tel', res.data.tel);
      call && call()
    }
  })
}
